/*
  Villa Amenity Lab V4 draft interactivity.
  Draft only. No app dependency.
*/

(function () {
  const money = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  });
  const whole = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

  const experienceMap = {
    "Wellness Retreat": {
      fragrance: "White Tea Serenity",
      mood: "Calm, clean, wellness-focused",
      products: "Shampoo, conditioner, body wash, hand wash",
      refill: "High"
    },
    "Beachfront Escape": {
      fragrance: "Ocean Breeze Escape",
      mood: "Fresh, coastal, relaxed",
      products: "Shampoo, body wash, hand wash",
      refill: "High"
    },
    "Luxury Resort": {
      fragrance: "White Orchid Elegance",
      mood: "Refined, floral, polished",
      products: "Shampoo, conditioner, body wash, lotion",
      refill: "Medium-high"
    },
    "Boutique Villa": {
      fragrance: "Bergamot Tea Harmony",
      mood: "Bright, modern, uplifting",
      products: "Shampoo, conditioner, body wash",
      refill: "High"
    },
    "Nature Retreat": {
      fragrance: "Bamboo Cedar Reserve",
      mood: "Earthy, tranquil, nature-focused",
      products: "Shampoo, body wash, hand wash",
      refill: "Very high"
    }
  };

  function selected(selector, root) {
    return root.querySelector(selector)?.value || "";
  }

  function activeText(selector, root) {
    return root.querySelector(`${selector}.is-active`)?.textContent.trim() || "";
  }

  function setText(root, selector, value) {
    const target = root.querySelector(selector);
    if (target) target.textContent = value;
  }

  function updateRoute(root, payload) {
    root.querySelectorAll("[data-val-v4-route]").forEach((link) => {
      const base = link.getAttribute("data-val-v4-base-url") || link.getAttribute("href") || "";
      if (!base) return;
      try {
        const url = new URL(base, window.location.origin);
        Object.entries(payload).forEach(([key, value]) => {
          if (value !== undefined && value !== null && String(value).trim() !== "") {
            url.searchParams.set(key, String(value));
          }
        });
        link.href = url.toString();
      } catch (error) {
        link.href = base;
      }
    });
  }

  function recommendation(quantity, rooms) {
    const sets = Number(quantity || 500);
    const roomCount = Number(rooms || 0);
    if (sets >= 3000 || roomCount >= 80) return "Custom Development";
    if (sets >= 1000 || roomCount >= 30) return "Private Label";
    return "Small Batch";
  }

  function updateAssessment(root) {
    const rooms = Number(selected("[data-val-v4-rooms]", root) || 72);
    const spend = Number(selected("[data-val-v4-spend]", root) || 3000);
    const quantity = Number(selected("[data-val-v4-quantity]", root) || 1000);
    const occupancy = Number(selected("[data-val-v4-occupancy]", root) || 65) / 100;
    const amenityType = selected("[data-val-v4-amenity-type]", root) || "Single-use Bottles";
    const propertyType = selected("[data-val-v4-property-type]", root) || "Resort";
    const region = selected("[data-val-v4-region]", root) || "Thailand";
    const painPoint = selected("[data-val-v4-pain-point]", root) || "Cost control";
    const annualSpend = spend * 12;
    const baselineMultiplier = amenityType === "Wall-mounted Dispensers" ? 1 : amenityType === "Refillable Bottles" ? 1.5 : amenityType === "Mixed" ? 2.1 : 3;
    const reductionRate = amenityType === "Wall-mounted Dispensers" ? 0.28 : amenityType === "Refillable Bottles" ? 0.48 : amenityType === "Mixed" ? 0.62 : 0.76;
    const savingsLow = annualSpend * (amenityType === "Wall-mounted Dispensers" ? 0.08 : 0.15);
    const savingsHigh = annualSpend * (amenityType === "Wall-mounted Dispensers" ? 0.18 : 0.35);
    const bottleUsage = Math.round(rooms * occupancy * 365 * baselineMultiplier);
    const reduction = Math.round(bottleUsage * reductionRate);
    const program = recommendation(quantity, rooms);
    const summary = `${propertyType}, ${rooms} rooms/villas, ${Math.round(occupancy * 100)}% occupancy, ${amenityType}, ${region}. Focus: ${painPoint}.`;

    setText(root, "[data-val-v4-program]", program);
    setText(root, "[data-val-v4-spend-output]", money.format(annualSpend));
    setText(root, "[data-val-v4-bottles-output]", whole.format(bottleUsage));
    setText(root, "[data-val-v4-reduction-output]", whole.format(reduction));
    setText(root, "[data-val-v4-savings-output]", `${money.format(savingsLow)}-${money.format(savingsHigh)}`);
    setText(root, "[data-val-v4-report-summary]", summary);
    setText(root, "[data-val-v4-efficiency-output]", amenityType === "Single-use Bottles" ? "Fewer restocking touches and less room-by-room packaging waste." : "Streamlined replenishment with stronger refill program tracking.");
    updateRoute(root, {
      source: "refill_savings_assessment",
      program,
      annual_spend: money.format(annualSpend),
      savings_range: `${money.format(savingsLow)}-${money.format(savingsHigh)}`,
      plastic_reduction: `${whole.format(reduction)} bottles`,
      summary
    });
  }

  function initAssessment(root) {
    root.querySelectorAll("input, select").forEach((field) => {
      field.addEventListener("input", () => updateAssessment(root));
      field.addEventListener("change", () => updateAssessment(root));
    });
    updateAssessment(root);
  }

  function initWheel(root) {
    const buttons = root.querySelectorAll("[data-val-v4-experience]");
    const fragrance = root.querySelector("[data-val-v4-wheel-fragrance]");
    const mood = root.querySelector("[data-val-v4-wheel-mood]");
    const products = root.querySelector("[data-val-v4-wheel-products]");
    const refill = root.querySelector("[data-val-v4-wheel-refill]");

    function render(label) {
      const item = experienceMap[label] || experienceMap["Wellness Retreat"];
      fragrance.textContent = `Recommended: ${item.fragrance}`;
      mood.textContent = item.mood;
      products.textContent = item.products;
      refill.textContent = item.refill;
      buttons.forEach((button) => button.classList.toggle("is-active", button.textContent.trim() === label));
      updateRoute(root, {
        source: "collection_wheel",
        experience: label,
        fragrance: item.fragrance,
        refill_compatibility: item.refill
      });
    }

    buttons.forEach((button) => {
      button.addEventListener("click", () => render(button.textContent.trim()));
    });
    render("Wellness Retreat");
  }

  function initSmallBatch(root) {
    const quantity = root.querySelector("[data-val-v4-small-batch-quantity]");
    const timeline = root.querySelector("[data-val-v4-small-batch-timeline]");
    const program = root.querySelector("[data-val-v4-small-batch-program]");
    const route = root.querySelector("[data-val-v4-small-batch-route]");

    function render() {
      const sets = Number(quantity?.value || 500);
      const recommended = sets >= 3000 ? "Scale-Up Set" : sets >= 1000 ? "Private Label Set" : "Starter Set";
      const guidance = sets >= 3000 ? "Private label now, custom development review available." : "Standard bottles with durable logo labels and limited fragrance selection.";
      if (program) program.textContent = `${recommended}: ${guidance}`;
      if (route) route.textContent = sets >= 3000 ? "Route to private label or custom review." : "Route to Small Batch Sample Kit Request.";
      updateRoute(root, {
        source: "small_batch_program",
        sets: `${sets} sets`,
        program: recommended,
        timeline: timeline?.value || "Standard"
      });
    }

    root.querySelectorAll("input, select").forEach((field) => {
      field.addEventListener("input", render);
      field.addEventListener("change", render);
    });
    render();
  }

  function initBuilder(root) {
    const quantity = root.querySelector("[data-val-v4-builder-quantity]");
    const rooms = root.querySelector("[data-val-v4-builder-rooms]");
    const program = root.querySelector("[data-val-v4-builder-program]");
    const moq = root.querySelector("[data-val-v4-builder-moq]");
    const preview = root.querySelector("[data-val-v4-preview]");
    const fragrance = root.querySelector("[data-val-v4-builder-fragrance]");
    const propertyType = root.querySelector("[data-val-v4-builder-property]");

    function render() {
      const result = recommendation(quantity?.value || 500, rooms?.value || 12);
      const bottleStyle = activeText("[data-val-v4-bottle-style]", root) || "Tall";
      const pumpStyle = activeText("[data-val-v4-pump-style]", root) || "Classic Pump";
      const bottleColor = activeText("[data-val-v4-bottle-color-label]", root) || "Warm Ivory";
      const pumpColor = activeText("[data-val-v4-pump-color-label]", root) || "Champagne";
      const fragranceValue = fragrance?.value || "White Tea Serenity";
      const summary = `${bottleStyle} bottle, ${bottleColor}, ${pumpStyle}, ${pumpColor}, ${fragranceValue}. ${propertyType?.value || "Hospitality property"}, ${rooms?.value || 12} rooms/villas, ${quantity?.value || 500} sets.`;
      if (program) program.textContent = result;
      if (moq) moq.textContent = result === "Small Batch" ? "500 sets" : result === "Private Label" ? "1000+ sets" : "MOQ review";
      const fragranceText = root.querySelector("[data-val-v4-builder-fragrance-output]");
      if (fragranceText && fragrance) fragranceText.textContent = fragranceValue;
      setText(root, "[data-val-v4-builder-summary]", summary);
      updateRoute(root, {
        source: "diy_builder",
        program: result,
        moq: moq?.textContent || "",
        fragrance: fragranceValue,
        summary
      });
    }

    root.querySelectorAll("input, select").forEach((field) => {
      field.addEventListener("input", render);
      field.addEventListener("change", render);
    });
    root.querySelectorAll("[data-val-v4-config-group]").forEach((group) => {
      group.querySelectorAll("button").forEach((button) => {
        button.addEventListener("click", () => {
          group.querySelectorAll("button").forEach((item) => item.classList.remove("is-active"));
          button.classList.add("is-active");
          if (button.dataset.bottleColor && preview) preview.style.setProperty("--val-v4-bottle-color", button.dataset.bottleColor);
          if (button.dataset.pumpColor && preview) preview.style.setProperty("--val-v4-pump-color", button.dataset.pumpColor);
          render();
        });
      });
    });
    render();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-val-v4-assessment]").forEach(initAssessment);
    document.querySelectorAll("[data-val-v4-wheel]").forEach(initWheel);
    document.querySelectorAll("[data-val-v4-small-batch]").forEach(initSmallBatch);
    document.querySelectorAll("[data-val-v4-builder]").forEach(initBuilder);
  });
})();
